import { plainToClass } from 'class-transformer';
import {
  API_FUNDING_SOURCE_CONTRACT_CREATE,
  API_FUNDING_SOURCE_CONTRACT_DELETE,
  API_FUNDING_SOURCE_CONTRACT_FIND_ALL,
  API_FUNDING_SOURCE_CONTRACT_FIND_ONE,
  API_FUNDING_SOURCE_CONTRACT_UPDATE
} from '../api.routes';
import { BaseApi } from './base.api';
import { FundingSourceContractDto } from '../dto';
import { FindAllResponse } from '../types';

export class FundingSourceContractApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<FundingSourceContractDto>> {
    return this.httpClient
      .get(API_FUNDING_SOURCE_CONTRACT_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(FundingSourceContractDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<FundingSourceContractDto> {
    return this.httpClient
      .get(API_FUNDING_SOURCE_CONTRACT_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(FundingSourceContractDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<FundingSourceContractDto> {
    return this.httpClient
      .post(API_FUNDING_SOURCE_CONTRACT_CREATE, data)
      .then(({ data }) => {
        return plainToClass(FundingSourceContractDto, data);
      });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<FundingSourceContractDto> {
    return this.httpClient
      .put(API_FUNDING_SOURCE_CONTRACT_UPDATE, data)
      .then(({ data }) => {
        return plainToClass(FundingSourceContractDto, data);
      });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_FUNDING_SOURCE_CONTRACT_DELETE, {
      pathParams: { uuid }
    });
  }
}
